import * as React from "react";
import { useState } from "react";
import { observer } from "mobx-react";
import "mapbox-gl/dist/mapbox-gl.css";
import { Button, ButtonGroup, Card, HStack } from "@chakra-ui/react";
import { t } from "i18next";
import { useStores } from "../../../../shared/stores/RootStore";
import { toast } from "../../../../shared/views/CustomToaster";

const PendingCoordChangesControlsBase: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const { osaNodeStore, osaWayStore } = useStores();

  if (osaNodeStore.pendingCoordsByNodeId.size === 0) return null;

  const way = osaWayStore.getSelected()!;

  const applyPendingCoords = async () => {
    setLoading(true);
    await osaNodeStore.applyPendingCoordChanges(way.id);
    toast("success", t(`osaway:mapBoxMatching.changesApplied`));
    await osaWayStore.refreshOsaWay(way.id);
    osaNodeStore.clearPendingCoordChanges();
    setLoading(false);
    await osaNodeStore.fetchNodes(way.id);
  };

  return (
    <HStack bottom={6} right={2} position="absolute" zIndex={1}>
      <Card.Root>
        <Card.Body p={2}>
          <ButtonGroup attached colorPalette="primary" size="sm">
            <Button
              variant="outline"
              disabled={!osaNodeStore.pendingCoordsByNodeId.size}
              loading={loading}
              onClick={() => {
                osaNodeStore.clearPendingCoordChanges();
              }}
            >
              {t(`osaway:mapBoxMatching.clear`)}
            </Button>
            <Button
              loading={loading}
              onClick={applyPendingCoords}
              disabled={!osaNodeStore.pendingCoordsByNodeId.size}
            >
              {t(`osaway:mapBoxMatching.apply`)}
            </Button>
          </ButtonGroup>
        </Card.Body>
      </Card.Root>
    </HStack>
  );
};

export const PendingCoordChangesControls = observer(
  PendingCoordChangesControlsBase
);
